import { setCookie, getCookie } from './cookies'

let getArguments = window.location.search
  .split(/\?|&/g)
  .filter((item) => item)
  .map((item) => item.split('='))
  .reduce((result, item) => {
    result[item[0]] = item[1]
    return result
  }, {})

if (globalThis.Shopify.whitelist) {
  let whitelistStrings = globalThis.Shopify.whitelist.split(',')

  let whitelistObj = {}
  whitelistStrings.map((item) => {
    if (getArguments[item]) {
      whitelistObj[item] = getArguments[item]
    }
  })

  let urlEncodedArguments = Object.entries(whitelistObj)
    .map(([key, val]) => `${key}=${val}`)
    .join('&')

  if (urlEncodedArguments && urlEncodedArguments.length > 0) {
    setCookie('queryString', urlEncodedArguments, 999)
  }

  const queryString = getCookie('queryString') || ''

  if (queryString && queryString.length) {
    let anchors = document.querySelectorAll('a')
    if (anchors) {
      anchors.forEach((item) => {
        const regExString = `^(/)|(${window.location.host})`
        const regEx = new RegExp(regExString)
        const hrefAttr = item.getAttribute('href')
        if (hrefAttr && hrefAttr.match(regEx)) {
          if (hrefAttr.match(/\?/g)) {
            item.href = `${hrefAttr}&${queryString}`
          } else {
            item.href = `${hrefAttr}?${queryString}`
          }
        }
      })
    }
  }
}
